export { useIsViewed, useViewed } from './model/useViewed';
